import { clearAbout } from "../../../store/actions/aboutActions";
import { authLogout } from "../../../store/actions/authActions";
import { clearMessage, setMessage } from "../../../store/actions/dialogActions";
import { setNotifications } from "../../../store/actions/notificationActions";
import API from "../../../store/api";
import { getAboutBySite } from "./getAboutBySite";

export const updateAbout = (id, aboutData, bearerAuth, siteId, formFunction) => {
  return async dispatch => {

    dispatch(setMessage({ type: 'LOAD' }))

    API.put(`/api/portal/about/${id}`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .send(aboutData)
      .ok(res => res.status === 200 || res.status === 401)
      .then((response) => {
        if (response.status === 200) {
          dispatch(clearMessage)
          dispatch(getAboutBySite(siteId, bearerAuth))
          dispatch(setNotifications({
            type: 'success',
            message: 'Successfully updated.'
          }))
          formFunction()
        } else if (response.status === 401) {
          dispatch(clearAbout);
          dispatch(authLogout);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          }
        }
        dispatch(setMessage({
          title: 'Update About Failed',
          message: message,
          type: 'ERR',
        }))
      })
  }
}